import { Avatar, AvatarProps, styled } from "@mui/material";

import React from "react";

export const CarePortalContainer = styled("div")(({ theme })=>({
  display: "flex",
  gap: "3rem",
  justifyContent: "flex-start",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: "1rem",
  },
}));

export const PetCareCardContainer = styled("div")(({ theme })=>({
  "display": "flex",
  "width": "18.75rem",
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
  "flexDirection": "column",
  "alignItems": "flex-start",
  "gap": "16px",
  "#pet_list_card": {
    [theme.breakpoints.down("md")]: {
      display: "grid",
      gap: "0.5rem",
      gridTemplateColumns: "repeat(auto-fill, minmax(10.5rem, 1fr))",
    },
  },
}));

export const PetCareDetailsCardContainer = styled("div")(({ theme })=>({
  "display": "flex",
  "padding": "1.5rem 1.5rem 3rem 1.5rem",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "1.5rem",
  "alignSelf": "stretch",
  "borderRadius": "0.75rem",
  "position": "relative",
  "background": theme.palette.white.main,
  [theme.breakpoints.down("md")]: {
    flexDirection: "row",
    alignItems: "flex-start",
  },
  ".pet_avatar_soc": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "0.75rem",
  },

  ".pet_details": {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "1.5rem",
    alignSelf: "stretch",
    [theme.breakpoints.down("md")]: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: "1rem",
      alignSelf: "start",
    },
  },

  ".info_section": {
    display: "flex",
    minWidth: "150px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
    alignSelf: "stretch",
  },
}));

export const PetListCard = styled("div")(({ theme })=>({
  "width": "100%",
  "display": "flex",
  "marginBottom": "0.5rem",
  "gap": "0.75rem",
  "padding": "0.75rem",
  "cursor": "pointer",
  "borderRadius": "0.5rem",
  "border": `1px solid ${theme.palette.taupe.dark}`,
  ".info": {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "0.25rem",
  },
  [theme.breakpoints.down("md")]: {
    alignItems: "center",
    padding: "0.6rem",
  },
}));

export const CategoriesPanelContainer = styled("div")(({ theme })=>({
  "display": "flex",
  "width": "100%",
  // [theme.breakpoints.down("lg")]: {
  //   width: "35rem",
  //   marginBottom: "2rem",
  // },
  // [theme.breakpoints.down("sm")]: {
  //   width: "355px",
  //   marginBottom: "2rem",
  // },
  "flexDirection": "column",
  "alignItems": "flex-start",
  "gap": "1rem",
  "flexGrow": 1,
}));

interface CategoryAvatarProps extends AvatarProps {
  isActive?: boolean;
  isWellness?: boolean;
};

export const CategoryAvatar = styled(({ isActive, isWellness, ...props }: CategoryAvatarProps) =>
  <Avatar {...props} />)(({ theme, isActive, isWellness })=>({
  padding: "2.5rem",
  backgroundColor: isActive ? isWellness ? theme.palette.info.main :
    theme.palette.primary.main : theme.palette.sand.main,
  border: `1px solid ${theme.palette.taupe.dark}`,
  cursor: "pointer",
  [theme.breakpoints.down("sm")]: {
    padding: "1.5rem",
  },
}));
